import { Locale } from "date-fns";
import nlBE from 'date-fns/locale/nl-BE';
import { LanguageOption } from "./LanguageOption";

export const LanguageOptionToLocaleRecord: Record<LanguageOption, Locale> = {
    nl: nlBE,
}